<template>
    <select v-model="internalValue">
        <option v-if="promptText" :value="promptValue">{{ promptText }}</option>
        <option v-for="optionKey in optionsOrder" v-text="options[optionKey]" :value="optionKey" />
    </select>
</template>

<script>
    export default {
        name: 'smart-select',
        props: {
            value: {
                default: null,
            },
            options: {
                type: Object,
                default() {
                    return {};
                }
            },
            optionsOrder: {
                type: Array,
                default() {
                    return Object.keys(this.options);
                }
            },
            promptValue: {
                default: ''
            },
            promptText: {
                type: String,
                default: 'Select a value',
            },
        },
        data() {
            return {
                internalValue: this.getInternalValueFromValue(this.value),
                sendUpdates: true
            }
        },
        methods: {
            getInternalValueFromValue(value) {
                if (value !== null) {
                    return value.toString();
                } else {
                    return this.promptValue.toString();
                }
            },
            setInternalValue(value) {
                this.internalValue = this.getInternalValueFromValue(value);
            }
        },
        watch: {
            value(value) {
                this.sendUpdates = false;

                this.$nextTick(() => {
                    this.sendUpdates = true;
                });
            },
            internalValue(value) {
                if (this.sendUpdates) {
                    this.$emit('input', value);
                }
            }
        }
    }
</script>